(function () {
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function moneyFromCents(cents) {
    if (cents == null || cents === "") return "";
    var n = Number(cents);
    if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(n);
    if (n > 1000 && n % 1 === 0) n = n / 100;
    return "Rs. " + n.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function merchName(title) {
    if (!title) return "";
    var parts = String(title).split(" | ");
    return parts[0].trim();
  }

  function initAnnouncement() {
    var root = qs("[data-ob-announcement]");
    if (!root) return;
    var raw = root.getAttribute("data-messages") || "";
    var messages = raw.split("||").map(function (m) { return m.trim(); }).filter(Boolean);
    if (!messages.length) return;
    var el = qs("[data-ob-announcement-msg]", root);
    if (!el) return;
    var i = 0;
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce || messages.length < 2) return;
    setInterval(function () {
      i = (i + 1) % messages.length;
      el.textContent = messages[i];
    }, 4000);
  }

  function initHeroCarousel() {
    var root = qs("[data-ob-hero-carousel]");
    if (!root) return;
    var slides = qsa("[data-ob-slide]", root);
    var dots = qsa("[data-ob-dot]", root);
    var badge = qs("[data-ob-badge]", root);
    var audience = qs("[data-ob-audience]", root);
    if (slides.length < 2) return;
    var index = 0;
    var paused = false;
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var ms = parseInt(root.getAttribute("data-autoplay") || "7000", 10);

    function show(i) {
      index = ((i % slides.length) + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        s.classList.toggle("is-active", n === index);
        s.setAttribute("aria-hidden", n === index ? "false" : "true");
      });
      dots.forEach(function (d, n) {
        d.classList.toggle("is-active", n === index);
      });
      var active = slides[index];
      if (badge) badge.textContent = active.getAttribute("data-title") || "";
      if (audience) audience.textContent = active.getAttribute("data-audience") || "";
    }

    var prev = qs("[data-ob-prev]", root);
    var next = qs("[data-ob-next]", root);
    if (prev) prev.addEventListener("click", function () { show(index - 1); });
    if (next) next.addEventListener("click", function () { show(index + 1); });
    dots.forEach(function (d, n) {
      d.addEventListener("click", function () { show(n); });
    });
    root.addEventListener("mouseenter", function () { paused = true; });
    root.addEventListener("mouseleave", function () { paused = false; });
    if (!reduce && ms > 0) {
      setInterval(function () { if (!paused) show(index + 1); }, ms);
    }
    show(0);
  }

  function initMobileNav() {
    var openBtn = qs("[data-ob-nav-open]");
    var drawer = qs("[data-ob-drawer]");
    if (!openBtn || !drawer) return;
    function setOpen(open) {
      drawer.setAttribute("data-open", open ? "true" : "false");
      document.documentElement.style.overflow = open ? "hidden" : "";
    }
    openBtn.addEventListener("click", function () { setOpen(true); });
    qsa("[data-ob-nav-close]", drawer).forEach(function (btn) {
      btn.addEventListener("click", function () { setOpen(false); });
    });
  }

  function initEditorialAssets() {
    var mapEl = document.getElementById("ob-editorial-assets");
    if (!mapEl) return;
    var map = {};
    try { map = JSON.parse(mapEl.textContent || "{}"); } catch (e) { return; }
    qsa("img[data-ob-asset]").forEach(function (img) {
      var key = img.getAttribute("data-ob-asset");
      if (key && map[key]) {
        img.src = map[key];
        img.removeAttribute("data-ob-asset");
      }
    });
  }

  function initPlp() {
    var sort = qs("[data-ob-sort]");
    if (sort) {
      sort.addEventListener("change", function () {
        var url = new URL(window.location.href);
        url.searchParams.set("sort_by", sort.value);
        window.location.href = url.toString();
      });
    }
    var form = qs("[data-ob-facets]");
    if (!form) return;
    form.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
      input.addEventListener("change", function () {
        if (window.matchMedia("(min-width: 768px)").matches) form.submit();
      });
    });
    var drawer = qs("[data-ob-facets-drawer]", form);
    var openBtn = qs("[data-ob-facets-open]", form);
    if (drawer && openBtn) {
      function setOpen(open) {
        drawer.setAttribute("data-open", open ? "true" : "false");
        document.documentElement.style.overflow = open ? "hidden" : "";
      }
      openBtn.addEventListener("click", function () { setOpen(true); });
      qsa("[data-ob-facets-close]", drawer).forEach(function (btn) {
        btn.addEventListener("click", function () { setOpen(false); });
      });
    }
  }

  function formatPredictivePrice(p) {
    if (p.price && String(p.price).indexOf("Rs") !== -1) return p.price;
    if (p.price) return moneyFromCents(p.price);
    return "";
  }

  function initSearch() {
    var root = qs("[data-ob-search]");
    var openBtn = qs("[data-ob-search-open]");
    if (!root || !openBtn) return;
    var input = qs("[data-ob-predictive-input]", root);
    var results = qs("[data-ob-predictive-results]", root);
    function setOpen(open) {
      root.setAttribute("data-open", open ? "true" : "false");
      document.documentElement.style.overflow = open ? "hidden" : "";
      if (open && input) input.focus();
    }
    openBtn.addEventListener("click", function () { setOpen(true); });
    qsa("[data-ob-search-close]", root).forEach(function (btn) {
      btn.addEventListener("click", function () { setOpen(false); });
    });
    var timer;
    if (input && results && window.obRoutes && window.obRoutes.predictiveSearch) {
      input.addEventListener("input", function () {
        clearTimeout(timer);
        var q = input.value.trim();
        if (q.length < 2) {
          results.hidden = true;
          results.innerHTML = "";
          return;
        }
        timer = setTimeout(function () {
          var url = window.obRoutes.predictiveSearch + "?q=" + encodeURIComponent(q) +
            "&resources[type]=product,query,article,page&resources[limit]=6&resources[options][unavailable_products]=last";
          fetch(url, { headers: { Accept: "application/json" } })
            .then(function (r) { return r.json(); })
            .then(function (data) {
              var html = "";
              var resources = (data && data.resources && data.resources.results) || {};
              (resources.products || []).forEach(function (p) {
                var img = (p.featured_image && p.featured_image.url) || p.image || "";
                html += '<a class="ob-search__hit" href="' + p.url + '">' +
                  (img ? '<img src="' + img + '" alt="">' : "<span></span>") +
                  "<span>" + merchName(p.title) + "</span>" +
                  "<span>" + formatPredictivePrice(p) + "</span></a>";
              });
              results.innerHTML = html || "<p>Nothing matching that joke yet.</p>";
              results.hidden = false;
            })
            .catch(function () {});
        }, 180);
      });
    }
  }

  function initSwatches() {
    qsa("[data-ob-card]").forEach(function (card) {
      var img = qs(".ob-card__img--primary", card);
      qsa("[data-ob-swatch]", card).forEach(function (btn) {
        btn.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          qsa("[data-ob-swatch]", card).forEach(function (b) { b.classList.remove("is-active"); });
          btn.classList.add("is-active");
          var src = btn.getAttribute("data-image");
          if (img && src) img.src = src;
        });
      });
    });
  }

  function openMinicart(cart) {
    var root = qs("[data-ob-minicart]");
    if (!root) {
      window.location.href = "/cart";
      return;
    }
    var body = qs("[data-ob-minicart-body]", root);
    var total = qs("[data-ob-minicart-total]", root);
    var html = "";
    (cart.items || []).forEach(function (item) {
      html += '<div class="ob-minicart__item">' +
        (item.image ? '<img src="' + item.image + '" alt="">' : "<span></span>") +
        "<div><p>" + merchName(item.product_title) + "</p><p>" + item.variant_title + "</p><p>" +
        moneyFromCents(item.final_line_price) +
        (item.original_line_price > item.final_line_price ? ' <s class="ob-minicart__was">' + moneyFromCents(item.original_line_price) + "</s>" : "") +
        "</p>" +
        (item.line_level_discount_allocations || []).map(function (a) {
          var title = a.discount_application && a.discount_application.title;
          return title ? '<p class="ob-minicart__discount">' + String(title).replace(/[<>&"]/g, "") + "</p>" : "";
        }).join("") +
        "</div></div>";
    });
    if (!html) html = '<p class="ob-minicart__empty">Your cart is suspiciously responsible.</p>';
    if (body) body.innerHTML = html;
    if (total) total.textContent = moneyFromCents(cart.total_price);
    root.hidden = false;
    root.setAttribute("data-open", "true");
    document.documentElement.style.overflow = "hidden";
  }

  function initMinicart() {
    var root = qs("[data-ob-minicart]");
    if (!root) return;
    function close() {
      root.setAttribute("data-open", "false");
      root.hidden = true;
      document.documentElement.style.overflow = "";
    }
    qsa("[data-ob-minicart-close]", root).forEach(function (btn) {
      btn.addEventListener("click", close);
    });
  }

  function rowsFromChart(data) {
    if (!data) return [];
    if (Array.isArray(data)) return data;
    if (Array.isArray(data.rows)) return data.rows;
    if (Array.isArray(data.sizes)) return data.sizes;
    if (Array.isArray(data.measurements)) return data.measurements;
    return [];
  }

  function extractDescSizeChart() {
    var wrap = qs("[data-ob-size-table]");
    var src = qs("[data-ob-desc-source]");
    if (!wrap || wrap.querySelector("table")) return;
    if (!src) return;
    var holder = document.createElement("div");
    holder.innerHTML = src.innerHTML;
    var table = null;
    holder.querySelectorAll("h2, h3, h4, h5, p, strong").forEach(function (el) {
      if (table) return;
      if (!/size chart/i.test(el.textContent || "")) return;
      var n = el.nextElementSibling;
      while (n && n.tagName !== "TABLE") n = n.nextElementSibling;
      if (n) table = n;
    });
    if (!table) table = holder.querySelector("table");
    if (!table) return;
    table.classList.add("ob-sheet__table");
    wrap.appendChild(table.cloneNode(true));
    qsa(".ob-pdp__accord-body").forEach(function (body) {
      body.querySelectorAll("h2, h3, h4, h5").forEach(function (h) {
        if (!/size chart/i.test(h.textContent || "")) return;
        var n = h.nextElementSibling;
        h.remove();
        if (n && n.tagName === "TABLE") n.remove();
      });
    });
  }

  function renderSizeTable() {
    var jsonEl = qs("[data-ob-size-json]");
    var wrap = qs("[data-ob-size-table]");
    if (!jsonEl || !wrap) return;
    var data;
    try { data = JSON.parse(jsonEl.textContent || "null"); } catch (e) { return; }
    var rows = rowsFromChart(data);
    if (!rows.length) return;
    var keys = [];
    rows.forEach(function (row) {
      Object.keys(row).forEach(function (k) {
        if (keys.indexOf(k) === -1) keys.push(k);
      });
    });
    var html = '<table class="ob-sheet__table"><thead><tr>';
    keys.forEach(function (k) {
      html += "<th>" + k.replace(/_/g, " ") + "</th>";
    });
    html += "</tr></thead><tbody>";
    rows.forEach(function (row) {
      html += "<tr>";
      keys.forEach(function (k) {
        html += "<td>" + (row[k] == null ? "" : row[k]) + "</td>";
      });
      html += "</tr>";
    });
    html += "</tbody></table>";
    wrap.innerHTML = html;
  }

  function initPdp() {
    var root = qs("[data-ob-pdp]");
    var form = qs("[data-ob-product-form]");
    if (!form) return;
    var jsonEl = qs("[data-ob-variant-json]");
    var idInput = qs("[data-ob-variant-id]", form);
    var atc = qs("[data-ob-atc]", form);
    var priceEl = qs("[data-ob-pdp-price]");
    var availEl = qs("[data-ob-avail]");
    var feedback = qs("[data-ob-atc-feedback]");
    var variants = [];
    try { variants = JSON.parse((jsonEl && jsonEl.textContent) || "[]"); } catch (e) { variants = []; }

    var gallery = qs("[data-ob-gallery]");
    var slides = qsa("[data-ob-slide]", gallery || document);
    var thumbs = qsa("[data-ob-thumb]", gallery || document);
    var dots = qsa("[data-ob-dot]", gallery || document);
    var viewport = qs("[data-ob-viewport]");
    var countEl = qs("[data-ob-count]");
    var index = 0;

    function showSlide(i, fromScroll) {
      if (!slides.length) return;
      index = ((i % slides.length) + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle("is-active", n === index); });
      thumbs.forEach(function (t, n) {
        t.classList.toggle("is-active", n === index);
        t.setAttribute("aria-current", n === index ? "true" : "false");
      });
      dots.forEach(function (d, n) { d.classList.toggle("is-active", n === index); });
      if (countEl) countEl.textContent = (index + 1) + " / " + slides.length;
      if (!fromScroll && viewport && window.matchMedia("(max-width: 899px)").matches) {
        var slide = slides[index];
        if (slide) viewport.scrollTo({ left: slide.offsetLeft, behavior: "smooth" });
      }
    }

    thumbs.forEach(function (t) {
      t.addEventListener("click", function () { showSlide(parseInt(t.getAttribute("data-index"), 10)); });
    });
    dots.forEach(function (d) {
      d.addEventListener("click", function () { showSlide(parseInt(d.getAttribute("data-index"), 10)); });
    });
    if (viewport) {
      viewport.addEventListener("scroll", function () {
        if (!window.matchMedia("(max-width: 899px)").matches) return;
        var w = viewport.clientWidth || 1;
            showSlide(Math.round(viewport.scrollLeft / w), true);
      }, { passive: true });
    }

    var lightbox = qs("[data-ob-lightbox]");
    var lightImg = qs("[data-ob-lightbox-img]");
    function openZoom(i) {
      if (!lightbox || !lightImg) return;
      showSlide(i);
      var slide = slides[index];
      var zoom = slide && slide.getAttribute("data-zoom");
      if (!zoom) return;
      lightImg.src = zoom;
      lightbox.hidden = false;
      document.documentElement.style.overflow = "hidden";
    }
    function closeZoom() {
      if (!lightbox) return;
      lightbox.hidden = true;
      if (lightImg) lightImg.src = "";
      document.documentElement.style.overflow = "";
    }
    qsa("[data-ob-zoom-open]").forEach(function (btn, n) {
      btn.addEventListener("click", function () { openZoom(n); });
    });
    if (lightbox) {
      var closeBtn = qs("[data-ob-lightbox-close]", lightbox);
      var prevBtn = qs("[data-ob-lightbox-prev]", lightbox);
      var nextBtn = qs("[data-ob-lightbox-next]", lightbox);
      if (closeBtn) closeBtn.addEventListener("click", closeZoom);
      if (prevBtn) prevBtn.addEventListener("click", function () { openZoom(index - 1); });
      if (nextBtn) nextBtn.addEventListener("click", function () { openZoom(index + 1); });
      var startX = 0;
      lightbox.addEventListener("touchstart", function (e) { startX = e.changedTouches[0].clientX; }, { passive: true });
      lightbox.addEventListener("touchend", function (e) {
        var dx = e.changedTouches[0].clientX - startX;
        if (dx > 40) openZoom(index - 1);
        if (dx < -40) openZoom(index + 1);
      }, { passive: true });
    }
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        closeZoom();
        var sheet = qs("[data-ob-size-sheet]");
        if (sheet && !sheet.hidden) sheet.hidden = true;
      }
    });

    function selectedOptions() {
      var map = {};
      qsa("[data-ob-option]:checked", form).forEach(function (input) {
        map[input.getAttribute("data-option-name")] = input.value;
      });
      return map;
    }

    function matchVariant() {
      var opts = selectedOptions();
      var values = Object.keys(opts).map(function (k) { return opts[k]; });
      return variants.find(function (v) {
        return values.every(function (val) { return v.options.indexOf(val) !== -1; });
      });
    }

    function markUnavailable() {
      var opts = selectedOptions();
      qsa("[data-ob-option]", form).forEach(function (input) {
        var name = input.getAttribute("data-option-name");
        var trial = Object.assign({}, opts);
        trial[name] = input.value;
        var trialVals = Object.keys(trial).map(function (k) { return trial[k]; });
        var match = variants.find(function (v) {
          return trialVals.every(function (val) { return v.options.indexOf(val) !== -1; });
        });
        var label = input.closest(".ob-pdp__chip");
        if (!label) return;
        var unavailable = !match || match.available === false;
        label.classList.toggle("is-unavailable", unavailable);
        input.disabled = !match;
      });
    }

    function applyVariant(v) {
      if (!v) return;
      idInput.value = v.id;
      if (atc) {
        atc.disabled = !v.available;
        atc.textContent = v.available ? "Add to cart" : "Sold out";
      }
      var stickyAtc = qs("[data-ob-sticky-atc]");
      if (stickyAtc) {
        stickyAtc.disabled = !v.available;
        stickyAtc.textContent = v.available ? "Add to cart" : "Sold out";
      }
      if (availEl) availEl.textContent = v.available ? "In stock" : "Currently sold out — the joke remains.";
      var pct = v.compare_money && v.markdown_pct > 0 ? v.markdown_pct : 0;
      var offText = pct ? pct + "% OFF" : "";
      if (priceEl) {
        var nowEl = qs("[data-ob-price-now]", priceEl);
        var wasEl = qs("[data-ob-price-was]", priceEl);
        var compareEl = qs("[data-ob-price-compare]", priceEl);
        var labelEl = qs("[data-ob-price-label]", priceEl);
        var offEl = qs("[data-ob-price-off]", priceEl);
        if (nowEl) nowEl.textContent = v.price_money;
        if (labelEl) labelEl.textContent = pct ? "Sale price" : "Price";
        if (compareEl) compareEl.textContent = pct ? v.compare_money : "";
        if (wasEl) wasEl.hidden = !pct;
        if (offEl) { offEl.textContent = offText; offEl.hidden = !pct; }
      }
      var mediaOff = qs("[data-ob-media-off]");
      if (mediaOff) { mediaOff.textContent = offText; mediaOff.hidden = !pct; }
      qsa("[data-ob-promo-pct]").forEach(function (el) {
        el.textContent = (pct ? "Extra " : "") + el.getAttribute("data-ob-promo-pct") + "% OFF";
      });
      var stickyPrice = qs("[data-ob-sticky-price]");
      if (stickyPrice) stickyPrice.textContent = v.price_money;
      var stickySize = qs("[data-ob-sticky-size]");
      if (stickySize) stickySize.textContent = (selectedOptions().Size || selectedOptions().size || "");
      if (v.featured_media_id) {
        var i = slides.findIndex(function (s) { return String(s.getAttribute("data-media-id")) === String(v.featured_media_id); });
        if (i >= 0) showSlide(i);
      }
      markUnavailable();
    }

    form.addEventListener("change", function () {
      applyVariant(matchVariant());
    });
    markUnavailable();

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var fd = new FormData(form);
      fetch("/cart/add.js", {
        method: "POST",
        headers: { Accept: "application/json" },
        body: fd
      }).then(function (r) {
        if (!r.ok) throw r;
        return fetch("/cart.js");
      }).then(function (r) { return r.json(); }).then(function (cart) {
        if (feedback) {
          feedback.hidden = false;
          feedback.textContent = "Added. The joke is now in your cart.";
        }
        openMinicart(cart);
      }).catch(function () {
        if (feedback) {
          feedback.hidden = false;
          feedback.textContent = "Couldn’t add that combination.";
        }
      });
    });

    var sheet = qs("[data-ob-size-sheet]");
    qsa("[data-ob-size-open]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (sheet) {
          sheet.hidden = false;
          document.documentElement.style.overflow = "hidden";
        }
      });
    });
    qsa("[data-ob-size-close]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (sheet) {
          sheet.hidden = true;
          document.documentElement.style.overflow = "";
        }
      });
    });
    renderSizeTable();
    extractDescSizeChart();

    var sticky = qs("[data-ob-sticky]");
    var formAtc = atc;
    if (sticky && formAtc && window.matchMedia("(max-width: 767px)").matches) {
      function onScroll() {
        var rect = formAtc.getBoundingClientRect();
        var show = rect.bottom < 80;
        sticky.hidden = !show;
        sticky.setAttribute("data-show", show ? "true" : "false");
      }
      window.addEventListener("scroll", onScroll, { passive: true });
      onScroll();
    }
  }

  function initRelated() {
    var root = qs("[data-ob-related]");
    if (!root || root.getAttribute("data-locked") === "metafield") return;
    var url = root.getAttribute("data-url");
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var inner = doc.querySelector("[data-ob-related]");
        if (inner && inner.querySelector(".ob-card")) {
          root.innerHTML = inner.innerHTML;
          initSwatches();
          syncPromos();
        }
      })
      .catch(function () {});
  }

  // Liquid renders with the server clock, but pages can be served from cache long after; re-check the window on the client.
  function syncPromos() {
    var now = Date.now();
    qsa("[data-ob-promo]").forEach(function (el) {
      var starts = Date.parse(el.getAttribute("data-starts"));
      var ends = Date.parse(el.getAttribute("data-ends"));
      el.hidden = isNaN(starts) || isNaN(ends) || now < starts || now >= ends;
    });
  }

  function initPromos() {
    syncPromos();
    window.setInterval(syncPromos, 60000);
    document.addEventListener("visibilitychange", function () {
      if (!document.hidden) syncPromos();
    });
  }

  function initFooterAccordions() {
    var items = qsa("[data-ob-footer-acc]");
    if (!items.length) return;
    var mq = window.matchMedia("(min-width: 900px)");
    function sync() {
      items.forEach(function (el) { el.open = mq.matches; });
    }
    sync();
    if (mq.addEventListener) mq.addEventListener("change", sync);
    else mq.addListener(sync);
  }

  document.addEventListener("DOMContentLoaded", function () {
    initAnnouncement();
    initHeroCarousel();
    initMobileNav();
    initEditorialAssets();
    initPlp();
    initSearch();
    initSwatches();
    initMinicart();
    initPdp();
    initRelated();
    initPromos();
    initFooterAccordions();
  });
})();
